import { PIN_MAX_LENGTH, PIN_MIN_LENGTH } from './pin-field';

/** Why a PIN failed the client-side policy. Mirrors the rules the backend enforces on create. */
export type PinValidationError = 'length' | 'repeated' | 'sequential';

const isRepeated = (pin: string): boolean => new Set(pin).size === 1;

const isSequential = (pin: string): boolean => {
  const direction = pin.charCodeAt(1) - pin.charCodeAt(0);
  if (Math.abs(direction) !== 1) {
    return false;
  }
  for (let index = 2; index < pin.length; index++) {
    if (pin.charCodeAt(index) - pin.charCodeAt(index - 1) !== direction) {
      return false;
    }
  }
  return true;
};

export const getPinValidationError = (
  pin: string,
  minLength = PIN_MIN_LENGTH,
  maxLength = PIN_MAX_LENGTH
): PinValidationError | undefined => {
  if (!/^\d+$/.test(pin)) {
    return 'length';
  }
  if (pin.length < minLength || pin.length > maxLength) {
    return 'length';
  }
  if (isRepeated(pin)) {
    return 'repeated';
  }
  if (isSequential(pin)) {
    return 'sequential';
  }
  return undefined;
};
